import { SUBJECTS_SLUGS_TYPE } from 'platform-components/src/typings';

import { SELECT_SCHOOLBOOK, FILTER_SCHOOLBOOKS } from './constants';

export const selectSchoolbook = (subject: SUBJECTS_SLUGS_TYPE, schoolbookId: string | null) =>
    <const>{
        type: SELECT_SCHOOLBOOK,
        schoolbookId,
        subject,
    };

export const filterSchoolbooks = (subject: SUBJECTS_SLUGS_TYPE, input: string) =>
    <const>{
        type: FILTER_SCHOOLBOOKS,
        input,
        subject,
    };
